module.exports = "/images/projects.svg?48b7d21572cb14abde38adbe5d216344";